v-container 
  v-row 
    v-col(cols="12")
      v-form(ref="formRef" v-model="valid" @submit.prevent="onSubmit")    
        v-card
          v-card-text
            patient-form()
            authorization-disclosure-form()
            cancellation-policy-form()
            financial-policy-form()
          v-card-actions.d-flex.justify-end
            if error
              .error.text-red-lighten-1 {{ error }}
            v-btn(color="primary" type="submit" :loading="loading") Submit
        
